export type BackfillStatus = "not_started" | "running" | "complete" | "failed" | null;

// MAX-4204: the backend marks the whole backfill "failed" when any follow-on step
// (historical events, tags, notes) throws, even though the leads/agents work is already
// committed chunk-by-chunk. Customers on fully-synced accounts then see a false
// "Sync Failed". The core sync the Status screen reports is leads and agents, so a
// "failed" overall flag with a completed leads phase is displayed as complete.
// A real leads-phase failure still reads "failed". MAX-4219 fixes the backend flag itself.
export function effectiveBackfillStatus(
    backfillStatus: BackfillStatus,
    backfillLeadsStatus: string | null | undefined,
): BackfillStatus {
    if (backfillStatus === "failed" && backfillLeadsStatus === "complete") {
        return "complete";
    }
    return backfillStatus;
}
